module.exports = __webpack_public_path__ + "assets/img/title-59e2053d.png";